function QuickBasket() {

    var self = this;

    this.$form = document.querySelector('.js-basket-form');
    this.$quickBasket = document.querySelector('.js-quick-basket');
    this.$quickBasketWrap = document.querySelector('.js-quick-basket__wrap');
    this.$count = document.querySelector('.js-basket-count .header-action__count');

    this.clearDuration = 300;
    this.clearDelay = 200;
    this.timeout = 6000;
    this.clear;


    this.init = function() {
        if (!this.$form) {
            return;
        }

        $(this.$form).on('submit', function(e) {
            e.preventDefault();
            self.clearErrors();

            $.ajax({
                url: $(this).attr('action'),
                type: $(this).attr('method'),
                data: $(this).serialize(),
                success: function(data) {
                    if (data.result) {
                        // Update the quick basket and the basket count
                        self.update(data.payload.count);
                        // Add the html to the quick basket
                        self.$quickBasketWrap.innerHTML = data.payload.html;
                        // Define the new quick basket container and close elements
                        self.$container = document.querySelector('.js-quick-basket__container');
                        self.$close = document.querySelector('.js-quick-basket__close');
                        // Assign click events to new elements
                        self.$close.onclick = self.deactivate.bind(self);
                        self.$quickBasket.onclick = self.deactivate.bind(self);
                        self.$container.onclick = function(e) {
                            e.stopPropagation();
                        };
                        Soho.GTM.addToBasket([data.payload.item], data.payload.currency);
                    } else {
                        if (data.payload.errors) {
                            console.log(data.payload.errors);
                            self.addErrors(data.payload.errors);
                        }
                    }
                }
            });
        });
    }

    this.update = function(count) {
        this.activate();
        this.$count.innerHTML = count;
        this.clear = setTimeout(this.deactivate.bind(this), this.timeout);
    }

    this.activate = function() {
        this.$quickBasket.classList.add('quick-basket--activating');
        setTimeout(function() {
            self.$quickBasket.classList.add('quick-basket--active');
            self.$close.focus();
        }, 200);
    }

    this.deactivate = function() {
        this.$quickBasket.classList.remove('quick-basket--active');
        setTimeout(function() {
            self.$quickBasket.classList.remove('quick-basket--activating');
            clearTimeout(self.clear);
        }, this.clearDuration + this.clearDelay);
    }

    this.clearErrors = function() {
        var fields = this.$form.querySelectorAll('.field');
        for (var index = 0; index < fields.length; index++) {
            var element = fields[index];
            element.classList.remove('field-error');
            var error = element.querySelector('p.error');
            if (error) {
                error.parentElement.removeChild(error);
            }
        }
    }

    this.addErrors = function(errors) {
        for (var name in errors) {
            if (errors.hasOwnProperty(name)) {
                var error = errors[name];
                this.addError(name, error);
            }
        }
    }

    this.addError = function(name, message)
    {
        var input = $('[name=' + name + ']', this.$form);
        var field = input.parent('.field').get(0);

        var error = document.createElement('p');
        error.classList.add('error');
        error.innerHTML = message;

        field.classList.add('field-error');
        field.appendChild(error);
    }
}
